import { styled } from '@mui/material/styles';

// modalStyles --------------------------------------------------------------

export const CoursesModalRow = styled('div', {
  shouldForwardProp: (p) => p !== 'selectable',
})(({ selectable }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  ...(selectable ? { cursor: 'pointer' } : {}),
}));

export const CoursesModalRowIcon = styled('span')({
  padding: 9,
});

export const CoursesGrayBG = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.action.disabledBackground,
}));

export const CoursesModalTitle = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
}));

export const CoursesSceneTitle = styled('div')({
  fontWeight: 'bold',
});

export const CoursesSceneText = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
}));

// default useStyles --------------------------------------------------------

export const CoursesSelectedContainer = styled('div')(({ theme }) => ({
  margin: `0 ${theme.spacing(1)}`,
}));

export const CoursesSelectedText = styled('div')(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  fontStyle: 'italic',
  padding: theme.spacing(2),
}));

export const CoursesButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(1),

  '& button': {
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,

    '&:first-child': {
      backgroundColor: theme.palette.common.black,
    },

    '&.accessButton': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

export const CoursesFormContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '0 auto',

  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiFormGroup-root': {
    backgroundColor: theme.palette.action.disabled,
    width: '85%',
    marginTop: theme.spacing(3),
    padding: `0 ${theme.spacing(1)}`,
  },
}));

export const CoursesModalContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const CoursesModalTitleHeader = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const CoursesNameRow = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const CoursesCenterLoader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center',
});

export const CoursesBarTitle = styled('div')({
  textAlign: 'center',
  width: '100%',
});

export const CoursesTitle = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CoursesProfileContainer = styled('div')({
  position: 'relative',
  top: 64,
});
